import React from 'react';
//import {authRoles} from '../../auth';

export const EquivalenciasListConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['master', 'rh', 'rh_not_signer', 'admin'],
    routes: [{
        path: '/equivalencias-list',
        component: React.lazy(() =>
            import ('./EquivalenciasList'))
    }]
};